// Mock data for ANTS Consulting Services Website

export const companyInfo = {
  name: "ANTS Consulting",
  tagline: "Excellence in Compliance & Certification",
  description: "We offer best value, innovative Training & Implementation Services. We employ only highly accomplished & passionate Consultants with 25+ years of experience.",
  email: "customercare@antscorp.com",
  phone: "+1 (555) 123-4567",
  address: "1420 Spring Hill Road, Suite 300 Mclean, VA 22102, USA"
};

export const navItems = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About Us", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" }
];

export const services = [
  {
    id: 1,
    title: "ISO Services",
    shortDesc: "Comprehensive ISO 9001, 20000-1, 27001 & 22301 implementation and certification support.",
    description: "Our ISO consulting services help organizations achieve and maintain compliance with international standards. We provide gap analysis, implementation support, internal audits, and certification preparation.",
    icon: "Shield",
    features: [
      "ISO 9001 Quality Management",
      "ISO 20000-1 IT Service Management",
      "ISO 27001 Information Security",
      "ISO 22301 Business Continuity",
      "Integrated Management Systems"
    ]
  },
  {
    id: 2,
    title: "CMMI Services",
    shortDesc: "Capability Maturity Model Integration assessment and process improvement services.",
    description: "We help organizations improve their processes through CMMI assessment and implementation. Our experts guide you through maturity level advancement and process optimization.",
    icon: "TrendingUp",
    features: [
      "CMMI Appraisals (SCAMPI)",
      "Process Improvement",
      "Maturity Level Assessment",
      "Training & Workshops",
      "Continuous Improvement Support"
    ]
  },
  {
    id: 3,
    title: "CMMC Services",
    shortDesc: "Cybersecurity Maturity Model Certification preparation for DoD contractors.",
    description: "Navigate the CMMC requirements with confidence. We provide comprehensive support for defense contractors seeking CMMC certification at all levels.",
    icon: "Lock",
    features: [
      "CMMC Readiness Assessment",
      "Gap Analysis & Remediation",
      "Policy & Procedure Development",
      "Security Control Implementation",
      "Certification Preparation"
    ]
  },
  {
    id: 4,
    title: "SOC Services",
    shortDesc: "System and Organization Controls auditing and compliance services.",
    description: "Our SOC services help organizations demonstrate their commitment to security and compliance through SOC 1, SOC 2, and SOC 3 reporting.",
    icon: "FileCheck",
    features: [
      "SOC 1 Type I & II Reports",
      "SOC 2 Type I & II Reports",
      "SOC 3 Reports",
      "Readiness Assessments",
      "Control Design & Testing"
    ]
  },
  {
    id: 5,
    title: "Training Services",
    shortDesc: "Professional certification training for ITIL, ISO Lead Auditor, and more.",
    description: "We offer comprehensive training programs delivered by certified instructors. Our training includes exam preparation with guaranteed pass rates.",
    icon: "GraduationCap",
    features: [
      "ITIL Foundation & Expert",
      "ISO Lead Auditor Training",
      "CISSP Preparation",
      "Custom Corporate Training",
      "Exam Pass Guarantee"
    ]
  },
  {
    id: 6,
    title: "Gap Analysis",
    shortDesc: "Thorough assessment to identify gaps and create actionable improvement plans.",
    description: "Our gap analysis services identify the differences between your current state and target compliance requirements, providing a clear roadmap for success.",
    icon: "Search",
    features: [
      "Current State Assessment",
      "Requirements Mapping",
      "Gap Identification",
      "Remediation Planning",
      "Priority Recommendations"
    ]
  }
];

export const whyChooseUs = [
  {
    title: "25+ Years Experience",
    description: "Our consultants bring decades of industry expertise to every engagement.",
    icon: "Award"
  },
  {
    title: "Certified Experts",
    description: "RABQSA certified auditors, ITIL experts, CISSP, CEH, and more.",
    icon: "BadgeCheck"
  },
  {
    title: "100% Pass Guarantee",
    description: "We offer exam pass guarantees for all our training programs.",
    icon: "Target"
  },
  {
    title: "On-Time Delivery",
    description: "We guarantee on-time project completion with milestone tracking.",
    icon: "Clock"
  },
  {
    title: "Best Value",
    description: "Competitive pricing without compromising on quality or results.",
    icon: "DollarSign"
  },
  {
    title: "End-to-End Support",
    description: "From assessment to certification and ongoing maintenance support.",
    icon: "HeartHandshake"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Kenneth Yienger",
    role: "Branch Head, Mission System Engineering, Goddard Space Flight Center, NASA",
    date: "January 25, 2010",
    content: "Sanjay was the technical glue that held our integration job together – from architecting the solution, to installation, check-out, and functional testing, through to operations and maintenance, Sanjay was invaluable and a trusted member of the GOES Resident Office Data Analysis System (GRODAS) Integration team. We had a mission-critical need with a tight deadline, and Sanjay’s team came through – even through rough spots both internal to his company and external beyond his control. The essence of Sanjay is that he provides you a solution that you need the best and most cost effective way possible – without thought of what is most expeditious to his company. He also personally accepts responsibility for the project’s success – he fit in well with our NASA team with his 100% devotion to project success. If we had another large scale, mission critical installation we had to accomplish, Sanjay would be my first (and last) phone call!"
  },
  {
    id: 2,
    name: "Major Richard Abelkis",
    role: "Deputy Director Technical Services, Defense Information Systems Agency (DISA)",
    date: "June 3, 2011",
    content: "Mr. Sanjay Barthakur, was a true patriot when we needed one. He volunteered to provide training on security systems we had procured. The training was comprehensive and he was always available to answer question for my team. The work he performed was always superior. I would gladly have him work on my team again."
  },
  {
    id: 3,
    name: "Scott Friedlander",
    role: "CEO President, GTSI",
    date: "June 14, 2011",
    content: "I always thought of Sanjay as a 'true athlete' in the information technology sport we all love and play. Sanjay is a high energy engineer with customer mission oriented problem solving capability. He can handle both pre-sales and post-sales assignments with multi vendor technologies. Every project that Sanjay delivered for our customers, became a great reference account for the company. Customers and his peers always had high regard for Sanjay's technical ability and his work ethic. I am a believer in his skills and proud to endorse Sanjay Barthakur."
  },
  {
    id: 4,
    name: "Dendy Young",
    role: "Chairman and CEO, GTSI",
    date: "May 7, 2010",
    content: "There are three words that come to mind in recommending Sanjay: integrity, intelligence, and commitment. He is honest, hard working, and committed to his customers. When he commits he always delivers. He will always exceed a customer’s expectations."
  },
  {
    id: 5,
    name: "Terri Allen",
    role: "Sr. Vice President, GTSI",
    date: "February 1, 2010",
    content: "Sanjay is the kind of person and has the skills you wish your entire team was made of. Whenever things got really tough or a client was very unhappy, we’d ask Sanjay to parachute in and save the day. This meant he had to travel to many locations around the world and solve problems many before him had tried to solve, and failed. When you want someone who is top notch both in terms of skills and client interaction, Sanjay is the very best person for the job."
  },
  {
    id: 6,
    name: "Rick Barnes",
    role: "Deputy Chief Information Officer, USPS OIG",
    date: "July 6, 2010",
    content: "I recall like it was yesterday, the first conversation I had with Sanjay. This was a younger Sanjay…when he still had black hair. At that very moment I realized that he was very special. Special, because not only did he already possess a keen business intellect, an intuition about people and solving their problems, but veracity that clearly identified him as one of the best engineers I had ever met. As I became friends with Sanjay, I saw he was a man with ethics, an unquestionable integrity, and a willingness and uncompromising drive through which he continuously pursued perfection. As the business landscape continues to transform, Sanjay remains engaged in evolutionary improvements where traditional business, process, and technology converge. Desktop to server and all points in-between, cyber-security, integration of modern core database application solutions, process improvement and budget control through disciplined accountability and oversight, and comprehensive integrity of all voice, video, and data transmissions. Experience = wisdom. Sanjay Barthakur continues to reinvent himself to address change, whether minor or significant, through his continuous improvements in capabilities, efficiencies, and purpose-built solutions for his customers."
  },
  {
    id: 7,
    name: "Kimberly Boarts",
    role: "VP Sales, Affigent",
    date: "May 5, 2010",
    content: "Sanjay provided relevant, real world examples during our three day ITIL Foundation training. His style and focus created a great learning environment. I would recommend him highly as an ITIL Instructor."
  },
  {
    id: 8,
    name: "Robert Strelser",
    role: "Channel Manager, HP",
    date: "January 19, 2010",
    content: "Sanjay is an expert in both the fields of ITIL and solutions architecture. Anyone who works with Sanjay understands he not only has the technical knowledge, but business savvy and communications to effectively assist any client in the field of IT consulting, training or architectural design (network, server, security and storage layers). I highly recommend him."
  },
  {
    id: 9,
    name: "Michael Lillie",
    role: "Systems Architect, GTSI",
    date: "January 20, 2010",
    content: "I believe that to be the best Systems Engineer/Architect you can be requires a person to set a standard to which aspire to. Sanjay is one of the people that I use as a standard to be measured against, and as a person whose skill set I measure my capabilities against. I have met very few people in my career that can consistently demonstrate the depth and breadth of knowledge that Sanjay has in Information Technology systems and processes. More importantly, I have never met anyone that can take this knowledge and apply it practically to resolve IT issues to the level that Sanjay can. To be more precise, Sanjay is the best of the best, as anyone who has worked with him can attest. I recommend Sanjay without hesitation."
  },
  {
    id: 10,
    name: "Rebecca Williams",
    role: "Service Monitoring Management Analyst, Accenture",
    date: "January 21, 2010",
    content: "Sanjay is conscientious and knowledgeable. He has high ethical standards and is dependable. He is committed to helping IT professionals learn and apply ITIL standards. I highly recommend him for any IT position and especially for ITIL training."
  },
  {
    id: 11,
    name: "Sammy Ho",
    role: "Manager, Verizon",
    date: "May 7, 2010",
    content: "I know Sanjay for many years. Beyond his excellent technical skill, Sanjay is also a fantastic ITIL trainer. He devoted many years of his time to become an ITIL expert. He is extremely knowledgeable about the ITIL process. His style and focus motivate people to learn the ITIL process and passing the ITIL certification exams. I highly recommend him to anyone for any ITIL related training."
  },
  {
    id: 12,
    name: "Rob Brosey",
    role: "Director, Business Development, FCN Inc.",
    date: "June 6, 2011",
    content: "Sanjay has the rare ability to recognize both the human and technical requirements involved in managing projects and new technology integrations. While working with Sanjay I was greatly impressed with his broad knowledge of the technology. He always had an answer for questions and when he didn’t know, he knew where to go to find out. Sanjay would be a tremendous asset to any organization, and then some."
  },
  {
    id: 13,
    name: "John M. Farrell",
    role: "Sr. Account Executive, Gartner Inc",
    date: "February 3, 2010",
    content: "Outstanding technical and business leader. Sanjay is highly skilled, thorough and a trusted resource for the most demanding projects. In my experience, he always comes up with the most innovative solutions that meet the client’s requirement with a full understanding of all available options. I was privileged to work alongside Sanjay and observe his talent throughout my tenure at GTSI. He’s my first choice for a CTO or a Chief Architect."
  },
  {
    id: 14,
    name: "Jodi Kohut",
    role: "Director, IT Engineering, Eyaktek LLC",
    date: "June 4, 2011",
    content: "There isn’t a business problem that can defeat the combination of technical expertise, business acumen, and passion that Sanjay brings to the equation. I’ve worked with Sanjay in a variety of capacities and he continues to impress me with his achievements. For these reasons and many more, I would highly recommend Sanjay and ANTS Corporation."
  },
  {
    id: 15,
    name: "Steve Sensabaugh",
    role: "Engineer, FCN Inc.",
    date: "May 24, 2011",
    content: "As a student of Sanjay's recent ITIL Foundation v3 class for FCN, I can honestly say that his class prepares you for ITIL 'implementation' and is also focused on material pertinent to passing the related exam. He supported concepts with real world examples and results. I strongly recommend his training, problem analysis, and solution architect offerings."
  },
  {
    id: 16,
    name: "Rick Ailstock",
    role: "Director, Systems Engineering, FCN",
    date: "May 17, 2011",
    content: "Sanjay provided the ITIL Foundation v3 training to the engineering staff at FCN. He did a great job of not only providing the instruction based on the class materials, but he also applied the material to real life scenarios. Sanjay’s teaching style helped the group have a 100% pass rate. We intend to use Sanjay for future ITIL training!"
  },
  {
    id: 17,
    name: "Steve Ferry",
    role: "Director, Sun Tech Team, GTSI",
    date: "May 6, 2010",
    content: "I have known Sanjay since the latter part of 1998 when we first met at GTSI and had a difference of opinion when it came to Firewall technologies available at the time. He had passion for his conviction in what firewall he preferred and I liked that in him. He soon became a part of the team and we worked on many opportunities together over the years where his knowledge, experience, passion and positive attitude won the business for us. He can always be depended on to do whatever it takes to get the job done once the customer committed to our proposed solution. He is truly one of a kind."
  },
  {
    id: 18,
    name: "Geoff Warren",
    role: "Director, Affigent",
    date: "May 5, 2010",
    content: "Sanjay was an excellent ITIL instructor who has expert knowledge on the subject and can also teach and relate the concepts to his students using real life examples. His enthusiasm and creativity keeps his students attentive and involved. I would highly recommend him to any individual or organization."
  },
  {
    id: 19,
    name: "Damon Collins",
    role: "ITIL, MCP",
    date: "May 4, 2010",
    content: "Sanjay is a fantastic ITIL trainer who is extremely knowledgeable about the ITIL process. He cares about his students and takes every measure possible to help them understand the concepts and pass the ITIL certification exams. He has high ethical standards and is dependable. He is committed to helping IT professionals learn and apply ITIL standards. I highly recommend him for any ITIL related training for individuals or business who want themselves or employees to become ITIL certified."
  },
  {
    id: 20,
    name: "Dwight Hamner",
    role: "Business Development Executive, GTSI",
    date: "January 22, 2010",
    content: "In my 20 years in sales I have seen a number of sales engineers, sometimes called pre-sales engineers, consultants, system architects, etc. Some are good, some great, some less so. But none have ever exceeded Sanjay Barthakur. What makes an engineer not merely good, but great? Customers love him, his peers respect him, sales people like me go to him first on any technical question. Still, that doesn’t do Sanjay justice. I grew up with DEC, as did Sanjay. And I could handle a lot of my own technical questions. But when I needed a miracle, I’d turn to Sanjay, and he would deliver. Always. If you want the best, and only the best will do, then Sanjay Barthakur is your first and only choice."
  },
  {
    id: 21,
    name: "Vicki Huchette",
    role: "Project Manager, Verizon",
    date: "January 21, 2010",
    content: "I have had the privilege of working with Sanjay in a variety of capacities and can attest to the fact that he is a multi-talented leader and educator. He is passionate, energetic, knowledgeable and is highly respected by his professional colleagues. One of Sanjay’s strengths is in formulating and delivering training on complex topics that draw on his extensive experience across diverse industries in a way that is always engaging, relevant and informative. His in-depth knowledge and expertise in ITSM, ITIL best practices, and strategic multivendor technology infrastructure design, planning and development — coupled with excellent communication and people skills — ensure that learning opportunities are always productive. Sanjay engages people, asks probing questions, listens attentively, and has that unique ability to explain and demonstrate technical content with a focus on solving a problem. When I took Sanjay’s ITIL V3 Foundation Training I was delighted with the quality and the completeness of his instruction and was then able to pass the exam with high marks. Sanjay is proactive and entrepreneurial yet he has a conscientious, respectful, and compassionate approach to client service and support. I am proud to have Sanjay in my professional circle, and would not hesitate to recommend him ."
  },
  {
    id: 22,
    name: "Rich Lum",
    role: "Director, Eyaktek LLC",
    date: "May 14, 2010",
    content: "Sanjay is a phenomenal technical resource who will craft the best solution for your customer’s needs and implement it in a way that leads to customer satisfaction for you and your customer!"
  },
  {
    id: 23,
    name: "Dante Brown",
    role: "Partner Solutions Consultant, GTSI Corp",
    date: "February 12, 2010",
    content: "Sanjay and I have worked together for several years as Sales Systems Engineers. Sanjay has always demonstrated deep technical knowledge. He continues to grow this knowledge by staying informed on the latest technologies. Sanjay does due diligence and performs first-hand, in-depth evaluation of leading edge solutions, so that he can provide value and concise recommendations. Across a broad spectrum of clients, Sanjay has established himself as a trustworthy technical advisor."
  },
  {
    id: 24,
    name: "Erin Ryan",
    role: "HHS Account Manager, GTSI Corp",
    date: "February 10, 2010",
    content: "I am very pleased to write this recommendation of Sanjay and his outstanding work ethic and technical acumen. During the year I worked with Sanjay on the Sun Technology Team at GTSI he was an outstanding resource to support our HHS customer. Sanjay possesses a unique ability as an engineer to make something very technical and quite complex understandable and clear to the layperson. His commitment to make sure that our customers were 110% satisfied by hanging in there with them every step of the way was outstanding. He has my utmost respect and I feel confident in giving him my personal recommendation."
  },
  {
    id: 25,
    name: "Ngoc Ho",
    role: "PeopleSoft Application Developer, GTSI",
    date: "January 20, 2010",
    content: "I worked with Sanjay at GTSI in supporting our ever changing Business needs. Sanjay was always ready to go the extra miles to make our customers happy. For every project Sanjay did for GTSI, he always received a great letter of appreciation from our customers. In shorts, our customers simply loved him. There is nothing he would not do to make our customer happy. Besides being a highly skilled technologist (ITIL Expert, CISSP, VCP, MCSE, CCNP etc), Sanjay also brought some real passion to our team. Sanjay was always a team player and showed his leadership skills in leading and training our in-house engineers at GTSI. I had the opportunity to work alongside Sanjay in several demanding projects at GTSI and would be extremely delighted to work with him again in future. I am happy to endorse Sanjay as he has rightfully earned my highest professional respects."
  }
];

export const stats = [
  { value: "500+", label: "Projects Completed" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "25+", label: "Years Experience" },
  { value: "100%", label: "Certification Rate" }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=80",
  heroBg: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1920&q=80",
  corporate: "https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg?w=1200&q=80",
  // ORIGINAL: Modern office workspace background used for Hero section
  office: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&q=80",
  security: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200&q=80",
  workspace: "https://images.unsplash.com/photo-1590065707046-4fde65275b2e?w=1200&q=80",
  team: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&q=80",
  consultation: "https://images.unsplash.com/photo-1573164574511-73c773193279?w=1200&q=80",
  corporateOffice: "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=1200&q=80"
};
